import { type FC } from 'react';
import { MenuIcon, XIcon } from 'src/components/media-and-icons/icons';
import { Logo } from 'src/components/media-and-icons/logo';
import { Link } from 'src/components/navigation/link';
import { cn } from 'src/utils/cn';

export const TopBar: FC<{
  open: boolean;
  // no toggle during loading
  setOpen?: (open: boolean) => void;
}> = ({ open, setOpen }) => {
  let isBrowser = true;
  try {
    // PRISMA_CONFIG isn't available on server-side render
    const iAvailabe = PRISMA_CONFIG;
  } catch {
    isBrowser = false;
  }

  return (
    <div
      className={`
        flex h-5xl items-center bg-background-sidebar-default p-xl
        px-[calc(var(--spacing-xl)+var(--spacing-lg))]
        md:hidden
        print:hidden
      `}
    >
      <div className="flex items-center gap-lg">
        <button
          data-testid={setOpen ? 'toggle-navigation' : undefined}
          onClick={() => setOpen?.(!open)}
          className={cn(
            'size-2xl text-foreground-sidebar-subdued',
            !setOpen && 'invisible'
          )}
          aria-label="Toggle Navigation"
          disabled={!setOpen}
        >
          {open ? <XIcon size="md" /> : <MenuIcon size="md" />}
        </button>

        {isBrowser ? (
          <Link to="/" mode="default">
            <Logo className="h-auto w-[96px]" />
          </Link>
        ) : (
          <a href="https://app.prisma-capacity.eu/platform/#/start">
            <Logo className="h-auto w-[96px]" />
          </a>
        )}
      </div>
    </div>
  );
};
